export default __webpack_public_path__ + "static/media/welcome.92597269.gif";